import React, { Component } from 'react'
import axios from 'axios';
import {BrowserRouter, NavLink, Route ,Switch} from 'react-router-dom';
import {Contact} from './Contact';
import { withRouter } from "react-router";
import Multiselect from 'multiselect-react-dropdown';
import queryString from 'query-string';
import { Button } from 'bootstrap';
class App extends Component {
  constructor (props){
    super(props);
    this.state = {
        copelist:[],
        levellist:[],
        techlist:[],
        testlist:[],
        clinetlist:[],
        servicegroup:"",
        tech:"",
        level:"",
        scope:"",
        techname:"",
        questions:[],
        AppList:[],
        ClientName:"",
        ClinetNamePass:"",
        OppName:"",
        App:"",
        technology:"",
        options: [],
        test:"",
        technologyname:"",
        AppName:"",
        STExecId:"0",
        STExecIdPass:"0",
        AppNamepass:"",
        Domain:"",
        DomainPass:"",
        DomainList:[],
        username:"",
        Admin:true,
        FunctionalAreaList:[],
        FunctionalArea:"",
        FunctionalAreaName:"Select",
        QuestionsFunctionalArea:[]
    }               
}


componentDidMount() {

  if(document.referrer == ""){
    window.location.replace('https://as-mobilization.accenture.com/Nest-Home.aspx');
  }
  else{
    this.handleQueryString();
    this.AdminCheck();
    this.getApp();
    this.GetClientName(); 
    this.GetOppName();
    this.getdomain();
    this.GetAllClientName();
    this.GetFunctionalAreaList();
    this.multiselectRef = React.createRef();
    this.multiselectRef2 = React.createRef();
    document.title ="KTPlanConfigurator";
  }
  
}


AdminCheck(){
  const options = {
    headers: {"content-type": "text/plain"}
  }
  axios.post('https://as-mobilization.accenture.com/api/Index/PostUsernameAdmin', {
    username: this.state.username
    },options)
    .then(res=> {     
      this.setState ( { Admin: res.data} );
      console.log(res);
        })
        .catch(err => {
          console.log(err);
      }) 
     
    
   
}
handleQueryString = () => {
  let queries = queryString.parse(window.location.search)
  if(queries.STExecId !=undefined)
  {
    this.state.STExecIdPass = queries.STExecId;
    const options = {
      headers: {"content-type": "text/plain"}
    }
    axios.post('https://as-mobilization.accenture.com/KTPlanConfig/api/Index/PostUsername', {
      username: queries.STExecId
    },options)
    .then(res=> {     
        
      this.setState ( { STExecId: res.data} );
      this.getApp();
      this.GetClientName(); 
        })
        .catch(err => {
          console.log(err);
      }) 
  } 
  if(queries.username !=undefined)
  {
    this.state.username = queries.username;
  }
  
}

GetClientName() {
  fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/Index/GetClientName/"+this.state.STExecId).then(response => response.json())
  .then(res=> {            
    this.setState ( { ClientName: res} )
    console.log(this.state.ClientName);
      })
      .catch(err => {
        console.log(err);
        
    }) 
}

GetAllClientName() {
  fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/Index/GetAllClientName/").then(response => response.json())
  .then(res=> {            
    this.setState ( { clinetlist: res} )
    console.log(this.state.clinetlist);
      })
      .catch(err => {
        console.log(err);
        
    }) 
}

getdomain() {
  fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/Index/Domains/"+2).then(response => response.json())
  .then(res=> {            
    this.setState ( { DomainList: res } )
      })
      .catch(err => {
        console.log(err);
    }) 
}
getscope() {
  fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/Index/ScopeList/"+this.state.servicegroup).then(response => response.json())
  .then(res=> {            
    this.setState ( { copelist: res,options:res } )
      })
      .catch(err => {
        console.log(err);
    }) 

    console.log(this.state.options);
}

getApp() {
  fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/Index/ApplicationList/"+this.state.STExecId).then(response => response.json())
  .then(res=> {            
    this.state.AppList = res;
    console.log(res);
      })
      .catch(err => {
        console.log(err);
    }) 
    console.log(this.state.AppList);
   
}



GetOppName() {
  fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/Index/GetOpportunityName/"+this.state.STExecId).then(response => response.json())
  .then(res=> {            
    this.setState ( { OppName: res} )
    console.log(this.state.OppName);
      })
      .catch(err => {
        console.log(err);
        
    }) 
}

getlevel() {
  fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/Index/LevelList/"+this.state.servicegroup).then(response => response.json())
  .then(res=> {            
    this.setState ( { levellist: res } )
      })
      .catch(err => {
        console.log(err);
    }) 

    

}

gettech() {
  fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/Index/TechnologyList/"+this.state.servicegroup).then(response => response.json())
  .then(res=> {            
    this.setState ( { techlist: res } )
      })
      .catch(err => {
        console.log(err);
    }) 

}
GetFunctionalAreaList() {
  fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/Index/GetFunctionalAreaList/").then(response => response.json())
  .then(res=> {            
    this.setState ( { FunctionalAreaList: res} )
    console.log(this.state.FunctionalAreaList);
      })
      .catch(err => {
        console.log(err);
        
    }) 
}

SGChange(e) {
  if(e.target.value != "Select")
  {
  this.state.servicegroup = e.target.value;
  this.gettech();
  this.getlevel();
  this.getscope();
  document.getElementById('divAll').style.display = 'block';
  this.multiselectRef2.current.resetSelectedValues();
  if(this.state.servicegroup.toString() == "IE")
  {
    document.getElementById('ddlTech').disabled = true;
    document.getElementById('ddlLevel').disabled = false;
    document.getElementById('mlScope').style.display = 'none';
    document.getElementById('txtAppNameDefault').style.display = 'none';
    document.getElementById('ddlFunctionalArea').disabled = true;
    document.getElementById('divFunctionalArea').style.display = 'none';
    document.getElementById('mlScope').style.marginBottom='10px';
    this.state.test = "4";
  }
  else
  {
    document.getElementById('mlScope').style.display = 'block';
    this.state.test = "";
    document.getElementById('ddlTech').disabled = false;
    document.getElementById('ddlFunctionalArea').disabled = false;
    document.getElementById('divFunctionalArea').style.display = 'block';
    document.getElementById('mlScope').style.marginBottom='10px';
  }
  }
  else
  {
    
    this.state.servicegroup = "";
    document.getElementById('divAll').style.display = 'none';
  }

}


Levelchange(e) {

  this.state.level = e.target.value;
  if(this.state.level == '1')
  {
    fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/Index/Domains/"+1).then(response => response.json())
    .then(res=> {            
      this.setState ( { DomainList: res } )
        })
        .catch(err => {
          console.log(err);
      }) 
    document.getElementById('ddlDomain').selectedIndex = 1;
    document.getElementById('ddlDomain').disabled = true;
    this.state.App = ",7";
   document.getElementById('ddlTech').disabled = false;
   axios.get("https://as-mobilization.accenture.com/KTPlanConfig/api/Index/TechnologyListIO/"+7)
   .then(res=> {            
     this.setState ( { techlist: res.data } )
       })
       .catch(err => {
         console.log(err);
     })  
  }
  else
  {
    this.getdomain();
    document.getElementById('ddlDomain').disabled = false;
    document.getElementById('ddlDomain').selectedIndex = 0;
    document.getElementById('ddlTech').disabled = this.state.servicegroup =="AO"?false:true;
    document.getElementById('ddlTech').selectedIndex = 0;
    this.state.tech = "";
    this.state.techname = "";
  }
 }

Appchange(e) {

 this.state.App = e.target.value;

 if(this.state.App == 'Other')
 {
  document.getElementById('txtAppName').style.display = 'block';
  document.getElementById('txtAppName').focus();
 }
 else
 {
  document.getElementById('txtAppName').style.display = 'none'
 }
}
Domainchange(e) {
  this.state.App = e.target.value;
  document.getElementById('ddlTech').disabled = false;
  axios.get("https://as-mobilization.accenture.com/KTPlanConfig/api/Index/TechnologyListIO/"+e.target.value)
  .then(res=> {            
    this.setState ( { techlist: res.data } )
      })
      .catch(err => {
        console.log(err);
    }) 
}

Clientchange(e) {
  if(e.target.value !='Select')
  {
  this.state.STExecId = e.target.value;
  this.state.ClientName = e.target.options[e.target.selectedIndex].text;
  fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/Index/ApplicationList/"+this.state.STExecId).then(response => response.json())
  .then(res=> { 
    this.setState ( { AppList: res } )           
    console.log(res);
      })
      .catch(err => {
        console.log(err);
    }) 
    console.log(this.state.AppList);
    document.getElementById('divApp').style.display = 'block'
    document.getElementById('txtAppNameDefault').style.display = 'none'
  }
  else
  {
    this.state.STExecId = 0;
    document.getElementById('divApp').style.display = 'none'
    document.getElementById('txtAppNameDefault').style.display = 'block'
  }
  if(this.state.servicegroup == "IE")
  {
    document.getElementById('divApp').style.display = 'none'
    document.getElementById('txtAppNameDefault').style.display = 'none'
  }
 
}
SetFunctionalArea(e) {
  if(e.target.selectedIndex!=0){
  this.state.FunctionalAreaName = (this.state.FunctionalAreaList[e.target.selectedIndex-1])['text'].toString();
  }
  else{
    this.state.FunctionalAreaName = "Select";
  }
}

onSelect(selectedList, selectedItem) {
  this.state.test ="";
 for(let i=0;i<selectedList.length;i++)
 {
   this.state.test += ","+selectedList[i].value;
 }
 if((this.state.test.toString().includes("1") || this.state.test.toString().includes("3")) && this.state.test.toString().length<=2)
 {

  document.getElementById('ddlLevel').disabled = false;
  document.getElementById('ddlLevel').selectedIndex = 0;
  this.state.level = "";
 }
 else if(this.state.test.toString() == ',1,3' || this.state.test.toString() == ',3,1')
 {
  document.getElementById('ddlLevel').disabled = false;
  document.getElementById('ddlLevel').selectedIndex = 0;
  this.state.level = "";
 }
 else
 {
  document.getElementById('ddlLevel').disabled = true;
  document.getElementById('ddlLevel').selectedIndex = 2;
  this.state.level = "2";
 }
 console.log(this.state.test);
}
adminClick(){
  this.props.history.push({

    pathname: '/AdminTechnology',
    
    state: {  username:this.state.username},

    search:"?username="+this.state.username,


  }) 
}
onRemove(selectedList, removedItem) {

  this.state.test ="";
  for(let i=0;i<selectedList.length;i++)
  {
    this.state.test += ","+selectedList[i].value;
  }
  if((this.state.test.toString().includes("1") || this.state.test.toString().includes("3")) && this.state.test.toString().length<=2)
 {
  document.getElementById('ddlLevel').disabled = false
  document.getElementById('ddlLevel').selectedIndex = 0;
  this.state.level = "";
 }
 else if(this.state.test.toString().includes("2") || this.state.test.toString().includes("3"))
 {
  document.getElementById('ddlLevel').disabled = true
  document.getElementById('ddlLevel').selectedIndex = 2;
  this.state.level = "2";
 }
 else
 {
  document.getElementById('ddlLevel').disabled = true
  document.getElementById('ddlLevel').selectedIndex = 0;
  this.state.level = "";
 }
  console.log(this.state.test);
}

onSelectTech(selectedList, selectedItem) {
  this.state.tech ="";
 for(let i=0;i<selectedList.length;i++)
 {
  this.state.tech += ","+selectedList[i].value;
 }
 console.log(this.state.tech);
}

onRemoveTech(selectedList, removedItem) {

  this.state.tech = this.state.tech.replace(removedItem.value+",","")
  console.log(this.state.tech);
}

resetClick() {

  window.location.reload(false);
}
onSelectApp(selectedList, selectedItem) {
  this.state.App ="";
 for(let i=0;i<selectedList.length;i++)
 {
  this.state.App += ","+selectedList[i].Application_Name;
 }
 if(this.state.App == ',Others')
 {
  document.getElementById('txtAppName').style.display = 'block'
  alert("Please specify Application Name below");
 }
 else
 {
  document.getElementById('txtAppName').style.display = 'none'
 }
 console.log(this.state.App);
}

onRemoveApp(selectedList, removedItem) {

  this.state.App = this.state.App.replace(removedItem.Application_Name+",","")
  if(removedItem.Application_Name != 'Others' && this.state.App.toString().includes("Others") )
 {
  document.getElementById('txtAppName').style.display = 'block'
  alert("Please specify Application Name below");
 }
 else
 {
  document.getElementById('txtAppName').style.display = 'none'
 }
  console.log(this.state.App);
}
editClick() {
  if(this.state.servicegroup == "IE" && (this.state.level == "" || this.state.tech == ""))
  {
    alert('Please select all mandatory fields to proceed');
    return;
  }
  else if(this.state.servicegroup == "AO" && (this.state.level == "" || this.state.tech == "" || this.state.App == ""))
  {
    alert('Please select all mandatory fields to proceed');
    return;
  }
  
  fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/Questions/GetLevel1QuestionsFunctionalAreaTasks/"+this.state.FunctionalAreaName).then(response => response.json())
  .then(res=> { 
    this.setState ( { QuestionsFunctionalArea: res } )     
      })
      .catch(err => {
        console.log(err);
    }) 

  fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/Questions/GetLevel1Questions/"+this.state.test+";"+(this.state.level.toString()==""?3:this.state.level)+";"+this.state.tech).then(response => response.json())
  .then(res=> { 
    if(res == "")
    {
     alert("Topics do not exist for this combination");
     return;
    }
    this.props.history.push({

      pathname: '/Contact',
      
      state: { questions: res,servicegroup:this.state.servicegroup, username:this.state.username, technology:this.state.tech ,AppName:this.state.App,STExecIdPass:this.state.STExecIdPass,AppNamepass:this.state.techname,ClinetNamePass:(this.state.ClientName.toString()==""?"":this.state.ClientName+"_"),QuestionsFunctionalArea:this.state.QuestionsFunctionalArea,FunctionalAreaName:this.state.FunctionalAreaName},
      
      search:"?username="+this.state.username
      
    })           
   
      })
      .catch(err => {
        console.log(err);
        
    }) 
}


  render() {
    const {
      tech
    }=this.state;
    return (
     
      <div class="bg-background" style={{background:'#F2F2F2'}}>
          <div class="row">
              <div class="container-fluid">
              <div class="header-content" style={{marginLeft:17}}>
                <img src="images/Capture.png" style={{paddingBottom:5}} alt="Accenture Technology" class="img-icon" />
                <span class="new-KT-navbar" style={{marginLeft:5}}>KT Plan Configurator</span>
                <button type='button' id='btnAdmin' style={{marginLeft:850,marginTop:5,display:(this.state.Admin?'block':'none')}}  className='btn-new btn-confirm' onClick={() => this.adminClick()}>Admin</button>
            </div>
                <div class="demographic-form margin-top15 border-main-div new-KT">
                  <div class="heading-desc" style={{paddingLeft:13}}>
                    Generate KT plan with simple inputs below and questionnaire :
                   
                    <a class="pull-right anchor-new-style" style={{margintop:0}} href="https://as-mobilization.accenture.com/Nest-STDashboard.aspx">Go Back
                    </a></div>
                 
                 

                  <div class="col-md-12 select-questions" style={{marginTop:-10}}>
                 
               

                 <div class="col-md-4" style={{marginBottom:-6}} >
                   <label for=" " class="control-label margin-bottom5  margin-top5" >Client Name</label>
                   <select  style={{width:275,height:37}} onChange={(e) => this.Clientchange(e)} name="ctl00$ContentPlaceHolder1$ddlIncludeGovernance"  id='ddlClient' class="aspNetDisabled form-control input-sm   textarea-style  margin-bottom5 watermark">
                   <option value='Select' text='Select'>Select</option>
                  
                   {
                        
                        this.state.clinetlist.map(list =>
                             <option value={list.STExecId} text={list.Client_Name} >{list.Client_Name}</option>)
                     }

                   </select>                  
                 </div>

                

                 <div class="col-md-4" >
                   <label for=" " class="control-label margin-bottom5  margin-top5" >Service Group *</label>
                   <select style={{width:275,height:37}} onChange={(e) => this.SGChange(e)} name="ctl00$ContentPlaceHolder1$ddlIncludeGovernance" id="ContentPlaceHolder1_ddlIncludeGovernance" class="aspNetDisabled form-control input-sm   textarea-style watermark">
                   <option value="Select">Select</option>
                   <option value="AO">AMS</option>
                   <option value="IE">IMS</option>
                  
                   </select>
                  
                 </div>

                <div id="divAll" style={{display:'none'}}>
              
                  <div class="col-md-4" id='mlScope'>
                      <label for=" " class="control-label margin-bottom5  margin-top5" >What is the scope of support for this application? *</label>
                     
                      <select style={{display:'none',width:275}} onChange={(e) => this.setState({scope: e.target.value})}  name="ctl00$ContentPlaceHolder1$ddlIncludeGovernance" id="ContentPlaceHolder1_ddlIncludeGovernance" class="aspNetDisabled form-control input-sm   textarea-style  margin-bottom5 watermark">
                      <option>Select</option>
                        {
                           
                           this.state.copelist.map(list =>
                                <option value={list.value}>{list.text}</option>)
                        }
                      </select>
                      <div>
                      <Multiselect
                      
                      options={this.state.options} 
                      selectedValues={this.state.selectedValue} 
                      onSelect={this.onSelect.bind(this)} 
                      onRemove={this.onRemove.bind(this)}
                      avoidHighlightFirstOption={true}
                      displayValue="text" 
                      ref={this.multiselectRef2}
                      />
                      </div>

                    </div>
                    <div class="col-md-4">
                      <label for=" " class="control-label margin-bottom5  margin-top5" >What is the level of support? *</label>
                      <select style={{width:275,height:36}} disabled={true}  onChange={(e) => this.Levelchange(e)}  name="ctl00$ContentPlaceHolder1$ddlIncludeGovernance"  id='ddlLevel' class="aspNetDisabled form-control input-sm   textarea-style  margin-bottom5 watermark">
                      <option>Select</option>
                       {
                           
                           this.state.levellist.map(list =>
                                <option value={list.value}>{list.text}</option>)
                        }
                      </select>
                     
                    </div>

                    <div class="col-md-4" >
                   <label for=" " class="control-label margin-bottom5  margin-top5"  >{this.state.servicegroup=="AO"?"What is the Application Name? *":"What is the Domain? *"}</label>
                   

                   <div id='divApp' style={{display:(this.state.STExecId == "0")?"none":(this.state.servicegroup == "IE"?"none":"block")}}>

                  <Multiselect
                    options={this.state.AppList} 
                    selectedValues={this.state.selectedList} 
                    onSelect={this.onSelectApp.bind(this)} 
                    onRemove={this.onRemoveApp.bind(this)}
                    avoidHighlightFirstOption={true}
                    displayValue="Application_Name" 
                    
                    />
                    </div>





                   <input type='text' onChange={(e) => this.setState({App: e.target.value})} style={{display:'none',height:38,width:275}} class='form-control input-sm '  placeholder='Please specify Application Name if others' id='txtAppName'></input>
                   <input type='text' onChange={(e) => this.setState({App: e.target.value})} style={{display:(this.state.STExecId == "0" && this.state.servicegroup == "AO")?"block":"none",height:38,width:275}} class='form-control input-sm ' id='txtAppNameDefault'></input>
                    <select  style={{display:this.state.servicegroup == "IE"?"block":"none",height:38,width:275}} onChange={(e) => this.Domainchange(e)} name="ctl00$ContentPlaceHolder1$ddlIncludeGovernance"  id='ddlDomain' class="aspNetDisabled form-control input-sm   textarea-style  margin-bottom5 watermark">
                   <option value='Select'>Select</option>
                  
                   {
                        
                        this.state.DomainList.map(list =>
                             <option value={list.value} >{list.text}</option>)
                     }

                   </select>
                 </div>
                


                    <div class="col-md-4">
                      <label for=" " class="control-label margin-bottom5  margin-top5" >{this.state.servicegroup=="AO"?"What is the  technology? *":"What is the IE Tower? *"} </label>
                      <select style={{width:275,height:38,display:'block',disabled:true}}  onChange={(e) => this.setState({tech: e.target.value,techname:e.target.options[e.target.selectedIndex].text})} name="ctl00$ContentPlaceHolder1$ddlIncludeGovernance" id='ddlTech' class="aspNetDisabled form-control input-sm   textarea-style  margin-bottom5 watermark">
                      <option>Select</option>
                      {
                           
                           this.state.techlist.map(list =>
                                <option value={list.value} key={list.text} >{list.text}</option>)
                        }

                      </select>
                      <div style={{display:'none'}}>
                      <Multiselect 
                      
                      options={this.state.techlist} 
                      selectedValues={this.state.selectedValue} 
                      onSelect={this.onSelectTech.bind(this)} 
                      onRemove={this.onRemoveTech.bind(this)}
                      avoidHighlightFirstOption={true}
                      ref={this.multiselectRef}
                      displayValue="text" 
                      
                      />
                     </div>
                    </div>
                  
               
                    <div id="divFunctionalArea" class="col-md-5">
                    <label for=" " class="control-label margin-bottom5  margin-top5" >Functional Area</label>
                      <select style={{width:275,height:38,display:'block',disabled:true}} onChange={(e) => this.SetFunctionalArea(e)} name="ctl00$ContentPlaceHolder1$ddlIncludeGovernance" id='ddlFunctionalArea' class="aspNetDisabled form-control input-sm   textarea-style  margin-bottom5 watermark">
                      <option>Select</option>
                      {
                           
                           this.state.FunctionalAreaList.map(list =>
                                <option value={list.value} key={list.text} >{list.text}</option>)
                        }

                      </select>
                      <div style={{display:'none'}}>
                      <Multiselect 
                      
                      options={this.state.FunctionalAreaList} 
                      selectedValues={this.state.selectedValue} 
                      avoidHighlightFirstOption={true}
                      ref={this.multiselectRef}
                      displayValue="text" 
                      
                      />
                     </div>
                    </div>


                    <div class="col-md-12 " >
                      <button type='button'  className='btn-new btn-confirm' onClick={() => this.editClick()}>Next</button>
                      <button type='button'  className='btn-new btn-confirm' onClick={() => this.resetClick()} style={{background:'#b455aa'}} >Reset</button>
                   
                     
                    </div>
                    </div>
                  </div>
                </div>
          </div>
        </div>
        <footer style={{background:'#F2F2F2',height:210}}>© 2026 Accenture. All Rights Reserved.
      </footer>
      </div>
     

    );
  }
}
export default withRouter(App);
